import React, { FC } from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  children?: React.ReactNode;
}

const Icon24: FC<Props> = ({ children, ...restProps }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      {children}
    </svg>
  );
};

const Plus: FC = () => {
  return (
    <Icon24>
      <path
        d="M12 5V12M12 12V19M12 12H19M12 12H5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const PlusTagGroup: FC = () => {
  return (
    <Icon24>
      <path
        d="M5.99999 6.99999H6.00999M14.1642 18.6642L12.4142 20.4142C11.6332 21.1953 10.3668 21.1953 9.58579 20.4142L2.58579 13.4142C2.19526 13.0237 2 12.5118 2 12V6.99999C2 4.79086 3.79086 3 5.99999 3H11C11.5119 2.99999 12.0237 3.19525 12.4142 3.58579L14.3284 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7V12M17 12V17M17 12H22M17 12H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Trash: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 8.05556H19.2222M18.3333 8.05556L17.5624 18.8489C17.4959 19.7792 16.7218 20.5 15.7892 20.5H8.4331C7.50041 20.5 6.72629 19.7792 6.65984 18.8489L5.88889 8.05556H18.3333ZM10.3333 11.6111V16.9444V11.6111ZM13.8889 11.6111V16.9444V11.6111ZM14.7778 8.05556V5.38889C14.7778 4.89797 14.3798 4.5 13.8889 4.5H10.3333C9.84242 4.5 9.44444 4.89797 9.44444 5.38889V8.05556H14.7778Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Close: FC = () => {
  return (
    <Icon24>
      <path
        d="M6 6L18 18M6 18L18 6L6 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Arrow: FC = () => {
  return (
    <Icon24>
      <path
        d="M14.9142 6.5139L20.3999 11.9996M20.3999 11.9996L14.9142 17.4853M20.3999 11.9996L11.257 11.9996C8.51419 11.9996 4.3999 9.25675 4.3999 5.59961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9142 17.4854L20.3999 11.9997M20.3999 11.9997L14.9142 6.51394M20.3999 11.9997L11.257 11.9997C9.42847 11.9997 4.3999 14.7425 4.3999 18.3997"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Warning: FC = () => {
  return (
    <Icon24>
      <path
        d="M12.5 8V12V8ZM12.5 16H12.51H12.5ZM21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3C17.4706 3 21.5 7.02944 21.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Chevron: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 13L9 17L19 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ChevronSimple: FC = () => {
  return (
    <Icon24>
      <path
        d="M16 10L12 14L8 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ChevronBadge: FC = () => {
  return (
    <Icon24>
      <path
        d="M9.00061 12.421L11.0006 14.421L15.0006 10.421M7.83535 5.11807C8.55288 5.06081 9.23407 4.77865 9.78193 4.31177C11.0604 3.22225 12.9408 3.22225 14.2193 4.31177C14.7672 4.77865 15.4483 5.06081 16.1659 5.11807C17.8403 5.25169 19.17 6.58133 19.3036 8.25576C19.3608 8.97329 19.643 9.65448 20.1099 10.2023C21.1994 11.4808 21.1994 13.3612 20.1099 14.6397C19.643 15.1875 19.3608 15.8687 19.3036 16.5863C19.17 18.2607 17.8403 19.5903 16.1659 19.724C15.4484 19.7812 14.7672 20.0634 14.2193 20.5303C12.9408 21.6198 11.0604 21.6198 9.78193 20.5303C9.23407 20.0634 8.55288 19.7812 7.83535 19.724C6.16092 19.5903 4.83128 18.2607 4.69766 16.5863C4.6404 15.8687 4.35824 15.1875 3.89136 14.6397C2.80184 13.3612 2.80184 11.4808 3.89136 10.2023C4.35824 9.65448 4.6404 8.97329 4.69766 8.25576C4.83128 6.58133 6.16092 5.25169 7.83535 5.11807Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Tags: FC = () => {
  return (
    <Icon24>
      <path
        d="M6.99999 6.99999H7.00999M6.99999 3H12C12.5119 2.99999 13.0237 3.19525 13.4142 3.58579L20.4143 10.5858C21.1953 11.3668 21.1953 12.6332 20.4143 13.4142L13.4142 20.4142C12.6332 21.1953 11.3668 21.1953 10.5858 20.4142L3.58579 13.4142C3.19526 13.0237 3 12.5118 3 12V6.99999C3 4.79086 4.79086 3 6.99999 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Italic: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.33337 18.2857V20H14.6191V18.2857H12.3962L14.5819 5.71429H16.9048V4H10.6191V5.71429H12.8419L10.6562 18.2857H8.33337Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const Bold: FC = () => {
  return (
    <Icon24>
      <path
        d="M11.963 4H6.33337V20H13.7408C14.781 19.9963 15.787 19.6279 16.5835 18.9589C17.38 18.2899 17.9167 17.3626 18.1 16.3387C18.2832 15.3148 18.1016 14.259 17.5866 13.3552C17.0716 12.4514 16.2559 11.7569 15.2815 11.3926C15.8491 10.7523 16.2198 9.96175 16.3491 9.11592C16.4783 8.27009 16.3607 7.40492 16.0103 6.62431C15.6599 5.8437 15.0916 5.18084 14.3736 4.71532C13.6557 4.2498 12.8187 4.00142 11.963 4ZM8.11115 5.77778H11.963C12.6702 5.77778 13.3485 6.05873 13.8486 6.55883C14.3487 7.05892 14.6297 7.7372 14.6297 8.44444C14.6297 9.15169 14.3487 9.82997 13.8486 10.3301C13.3485 10.8302 12.6702 11.1111 11.963 11.1111H8.11115V5.77778ZM16.4074 15.5556C16.4074 16.2628 16.1265 16.9411 15.6264 17.4412C15.1263 17.9413 14.448 18.2222 13.7408 18.2222H8.11115V12.8889H13.7408C14.448 12.8889 15.1263 13.1698 15.6264 13.6699C16.1265 14.17 16.4074 14.8483 16.4074 15.5556Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const H1: FC = () => {
  return (
    <Icon24>
      <path d="M3 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10.4286 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M3.00003 12.5H10.4286"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.4286 11.25H17.7302V19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const H2: FC = () => {
  return (
    <Icon24>
      <rect width="24" height="24" transform="translate(0.5)" />
      <path d="M4.07141 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M11.5 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M4.07141 12.5H11.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M14.75 11.5739C16.6189 11.574 18.4877 11.1378 19.1107 12.3837C19.7336 13.6296 18.0878 14.5191 16.6189 15.4985C15.1499 16.4778 15.373 18.25 15.373 18.25H20.3566"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const H3: FC = () => {
  return (
    <Icon24>
      <rect width="24" height="24" transform="translate(0.5)" />
      <path d="M4.07141 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M11.5 6V12.5V19" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M4.07141 12.5H11.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M19.4836 11.5L20.0442 11.9983C20.2404 11.7775 20.2888 11.4622 20.1678 11.1928C20.0468 10.9233 19.779 10.75 19.4836 10.75V11.5ZM16.9918 14.3032L16.4312 13.805C16.235 14.0257 16.1866 14.3411 16.3076 14.6105C16.4286 14.8799 16.6965 15.0532 16.9918 15.0532V14.3032ZM15.8704 16.8077L15.2601 16.3718L14.3882 17.5924L14.9985 18.0283L15.8704 16.8077ZM14.5 12.25H19.4836V10.75H14.5V12.25ZM18.9231 11.0017L16.4312 13.805L17.5524 14.8015L20.0442 11.9983L18.9231 11.0017ZM16.9918 15.0532C17.6252 15.0532 18.1618 15.0935 18.533 15.2738C18.6982 15.354 18.8116 15.454 18.89 15.584C18.9702 15.7171 19.0451 15.9342 19.0451 16.2967H20.5451C20.5451 15.7248 20.4253 15.2255 20.1746 14.8096C19.922 14.3906 19.5682 14.109 19.1883 13.9245C18.4693 13.5753 17.6043 13.5532 16.9918 13.5532V15.0532ZM19.0451 16.2967C19.0451 16.8899 18.7273 17.2731 18.22 17.4229C17.6769 17.5832 16.823 17.4881 15.8704 16.8077L14.9985 18.0283C16.2262 18.9052 17.5526 19.1839 18.6447 18.8615C19.7727 18.5285 20.5451 17.5723 20.5451 16.2967H19.0451Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const OrderedList: FC = () => {
  return (
    <Icon24>
      <path
        d="M7.2 11.1333V5.8C7.2 5.58783 7.11571 5.38434 6.96568 5.23431C6.81565 5.08429 6.61217 5 6.4 5H4V6.6H5.6V11.1333H7.2Z"
        fill="currentColor"
      />
      <path d="M20 5.26672H10.1333V6.86672H20V5.26672Z" fill="currentColor" />
      <path d="M20 9.53333H10.1333V11.1333H20V9.53333Z" fill="currentColor" />
      <path d="M20 13.8H10.1333V15.4H20V13.8Z" fill="currentColor" />
      <path d="M20 18.0667H10.1333V19.6666H20V18.0667Z" fill="currentColor" />
      <path
        d="M5.17601 16.2907C4.80208 16.6634 4.50564 17.1065 4.30381 17.5944C4.10197 18.0823 3.99872 18.6053 4.00001 19.1333C4.00001 19.3455 4.0843 19.549 4.23433 19.699C4.38436 19.849 4.58784 19.9333 4.80001 19.9333H8.00001V18.3333H5.73601C5.85591 17.9908 6.05193 17.6799 6.30934 17.424L7.22401 16.5093C7.4689 16.2658 7.63583 15.9549 7.70358 15.6162C7.77133 15.2776 7.73684 14.9264 7.60449 14.6074C7.47213 14.2884 7.2479 14.0159 6.9603 13.8247C6.6727 13.6334 6.33472 13.532 5.98934 13.5333H4.00001V15.1333H5.98934C6.01715 15.134 6.04416 15.1427 6.06712 15.1584C6.09007 15.1741 6.10799 15.1961 6.11871 15.2218C6.12943 15.2475 6.13248 15.2757 6.12751 15.3031C6.12253 15.3304 6.10974 15.3558 6.09068 15.376L5.17601 16.2907Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const BulletList: FC = () => {
  return (
    <Icon24>
      <path d="M20 4H4V5.77778H20V4Z" fill="currentColor" />
      <path d="M16.4444 8.77783H8.74072V10.5556H16.4444V8.77783Z" fill="currentColor" />
      <path
        d="M4.88889 10.5556C5.37981 10.5556 5.77778 10.1576 5.77778 9.66672C5.77778 9.1758 5.37981 8.77783 4.88889 8.77783C4.39797 8.77783 4 9.1758 4 9.66672C4 10.1576 4.39797 10.5556 4.88889 10.5556Z"
        fill="currentColor"
      />
      <path d="M16.4444 13.5557H8.74072V15.3334H16.4444V13.5557Z" fill="currentColor" />
      <path
        d="M4.88889 15.3334C5.37981 15.3334 5.77778 14.9355 5.77778 14.4446C5.77778 13.9536 5.37981 13.5557 4.88889 13.5557C4.39797 13.5557 4 13.9536 4 14.4446C4 14.9355 4.39797 15.3334 4.88889 15.3334Z"
        fill="currentColor"
      />
      <path d="M20 18.3335H8.74072V20.1113H20V18.3335Z" fill="currentColor" />
      <path
        d="M4.88889 20.1113C5.37981 20.1113 5.77778 19.7133 5.77778 19.2224C5.77778 18.7315 5.37981 18.3335 4.88889 18.3335C4.39797 18.3335 4 18.7315 4 19.2224C4 19.7133 4.39797 20.1113 4.88889 20.1113Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const Link: FC = () => {
  return (
    <Icon24>
      <path
        d="M14.0643 9.93571C13.4392 9.3108 12.5915 8.95975 11.7076 8.95975C10.8237 8.95975 9.97605 9.3108 9.35096 9.93571L6.01763 13.269C5.69926 13.5765 5.44532 13.9443 5.27062 14.351C5.09593 14.7577 5.00397 15.1951 5.00013 15.6377C4.99628 16.0803 5.08062 16.5192 5.24822 16.9289C5.41582 17.3385 5.66333 17.7107 5.97631 18.0237C6.28929 18.3367 6.66146 18.5842 7.07111 18.7518C7.48077 18.9194 7.9197 19.0037 8.3623 18.9999C8.8049 18.996 9.2423 18.9041 9.64898 18.7294C10.0557 18.5547 10.4235 18.3007 10.731 17.9824L11.6493 17.0649M11.0176 12.9824C11.6427 13.6073 12.4904 13.9583 13.3743 13.9583C14.2582 13.9583 15.1059 13.6073 15.731 12.9824L19.0643 9.64904C19.6715 9.02037 20.0075 8.17836 19.9999 7.30437C19.9923 6.43038 19.6417 5.59434 19.0237 4.97631C18.4057 4.35828 17.5696 4.00772 16.6956 4.00013C15.8216 3.99253 14.9796 4.32851 14.351 4.93571L13.4343 5.85237"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Image: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 14.9975L8.82071 11.1768C9.13318 10.8644 9.55692 10.6889 9.99875 10.6889C10.4406 10.6889 10.8643 10.8644 11.1768 11.1768L14.9975 14.9975M13.3312 13.3312L14.6526 12.0099C14.9651 11.6975 15.3888 11.5221 15.8306 11.5221C16.2725 11.5221 16.6962 11.6975 17.0087 12.0099L18.33 13.3312M13.3312 8.3325H13.3396M6.66625 18.33H16.6637C17.1057 18.33 17.5295 18.1544 17.842 17.842C18.1544 17.5295 18.33 17.1057 18.33 16.6637V6.66625C18.33 6.22433 18.1544 5.80052 17.842 5.48803C17.5295 5.17555 17.1057 5 16.6637 5H6.66625C6.22433 5 5.80052 5.17555 5.48803 5.48803C5.17555 5.80052 5 6.22433 5 6.66625V16.6637C5 17.1057 5.17555 17.5295 5.48803 17.842C5.80052 18.1544 6.22433 18.33 6.66625 18.33Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Badge: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.99963 12.0001L10.9996 14.0001L14.9996 10.0001M7.83437 4.69717C8.5519 4.63991 9.23309 4.35775 9.78095 3.89087C11.0594 2.80135 12.9398 2.80135 14.2183 3.89087C14.7662 4.35775 15.4473 4.63991 16.1649 4.69717C17.8393 4.83079 19.169 6.16043 19.3026 7.83486C19.3598 8.55239 19.642 9.23358 20.1089 9.78144C21.1984 11.0599 21.1984 12.9403 20.1089 14.2188C19.642 14.7666 19.3598 15.4478 19.3026 16.1654C19.169 17.8398 17.8393 19.1694 16.1649 19.3031C15.4474 19.3603 14.7662 19.6425 14.2183 20.1094C12.9398 21.1989 11.0594 21.1989 9.78095 20.1094C9.23309 19.6425 8.5519 19.3603 7.83437 19.3031C6.15994 19.1694 4.8303 17.8398 4.69668 16.1654C4.63942 15.4478 4.35726 14.7666 3.89038 14.2188C2.80086 12.9403 2.80086 11.0599 3.89038 9.78144C4.35726 9.23358 4.63942 8.55239 4.69668 7.83486C4.8303 6.16043 6.15994 4.83079 7.83437 4.69717Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Video: FC = () => {
  return (
    <Icon24>
      <path
        d="M15.2891 10L19.8419 7.72361C20.5068 7.39116 21.2891 7.87465 21.2891 8.61803V15.382C21.2891 16.1253 20.5068 16.6088 19.8419 16.2764L15.2891 14V10ZM5.28906 18H13.2891C14.3937 18 15.2891 17.1046 15.2891 16V8C15.2891 6.89543 14.3937 6 13.2891 6H5.28906C4.18449 6 3.28906 6.89543 3.28906 8V16C3.28906 17.1046 4.18449 18 5.28906 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ZoomIcon: FC = () => {
  return (
    <Icon24>
      <path
        d="M1 8.5C1 7.39543 1.89543 6.5 3 6.5H13C15.2091 6.5 17 8.29086 17 10.5V17.5C17 18.6046 16.1046 19.5 15 19.5H5C2.79086 19.5 1 17.7091 1 15.5V8.5Z"
        fill="#2D8CFF"
      />
      <path
        d="M18 10.0662C18 9.71493 18.1843 9.38942 18.4855 9.2087L21.4855 7.4087C22.152 7.00878 23 7.4889 23 8.26619V17.7338C23 18.5111 22.152 18.9912 21.4855 18.5913L18.4855 16.7913C18.1843 16.6106 18 16.2851 18 15.9338V10.0662Z"
        fill="#2D8CFF"
      />
    </Icon24>
  );
};

const Hide: FC = () => {
  return (
    <Icon24>
      <path
        d="M12 7.38525C8.1761 7.38525 3 10.7705 3 11.8989C3 13.0273 8.1761 16.4125 12 16.4125C15.8239 16.4125 21 13.0273 21 11.8989C21 10.7705 15.8239 7.38525 12 7.38525Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M14.625 11.8989C14.625 13.3564 13.4476 14.5341 12 14.5341C10.5524 14.5341 9.375 13.3564 9.375 11.8989C9.375 10.4414 10.5524 9.26367 12 9.26367C13.4476 9.26367 14.625 10.4414 14.625 11.8989Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="19.4912"
        y1="5.56677"
        x2="4.4912"
        y2="18.5668"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </Icon24>
  );
};

const Calendar: FC = () => {
  return (
    <Icon24>
      <path
        d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Lightning: FC = () => {
  return (
    <Icon24>
      <path
        d="M13 10V3L4 14H11V21L20 10H13Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ExclamationCircle: FC = () => {
  return (
    <Icon24>
      <path
        d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const AISpinner: FC = () => {
  return (
    <Icon24>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 1C5.13447 1.73159 1 6.33226 1 11.8986C1 17.9737 5.92487 22.8986 12 22.8986C17.5663 22.8986 22.167 18.7641 22.8986 13.3986H20.8756C20.1614 17.6552 16.4595 20.8986 12 20.8986C7.02944 20.8986 3 16.8691 3 11.8986C3 7.43909 6.24343 3.73714 10.5 3.02302V1Z"
        fill="url(#paint0_linear_2133_147)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2133_147"
          x1="11.9493"
          y1="1"
          x2="11.9493"
          y2="22.8986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8C0F8" />
          <stop offset="1" stopColor="#D1DDFF" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const Insight: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 3V7V3ZM3 5H7H3ZM6 17V21V17ZM4 19H8H4ZM13 3L15.2857 9.85714L21 12L15.2857 14.1429L13 21L10.7143 14.1429L5 12L10.7143 9.85714L13 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Cluster: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_7433_34938)">
        <path
          d="M5.00003 15H10.125C10.746 15 11.25 15.504 11.25 16.125V18.375C11.25 18.996 10.746 19.5 10.125 19.5H5.00003M2.25003 7.125C2.25003 6.504 2.75403 6 3.37503 6H9.37503C9.99603 6 10.5 6.504 10.5 7.125V10.875C10.5 11.496 9.99603 12 9.37503 12H3.37503C3.07666 12 2.79051 11.8815 2.57954 11.6705C2.36856 11.4595 2.25003 11.1734 2.25003 10.875V7.125ZM14.25 8.625C14.25 8.004 14.754 7.5 15.375 7.5H18H20.625C21.246 7.5 21.75 8.004 21.75 8.625V16.875C21.75 17.496 21.246 18 20.625 18H15.375C15.0767 18 14.7905 17.8815 14.5795 17.6705C14.3686 17.4595 14.25 17.1734 14.25 16.875V8.625Z"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.50003 16V19M1.00003 17.5H4.00003"
          stroke="#8E84EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 2L13.5715 3.90476L15 4.5L13.5715 5.09525L13 7L12.4286 5.09525L11 4.5L12.4286 3.90476L13 2Z"
          stroke="url(#paint0_linear_7433_34938)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7433_34938"
          x1="13"
          y1="2"
          x2="13"
          y2="7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
        <clipPath id="clip0_7433_34938">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const ClusterGray: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 15H10.125C10.746 15 11.25 15.504 11.25 16.125V18.375C11.25 18.996 10.746 19.5 10.125 19.5H5M2.25 7.125C2.25 6.504 2.754 6 3.375 6H9.375C9.996 6 10.5 6.504 10.5 7.125V10.875C10.5 11.496 9.996 12 9.375 12H3.375C3.07663 12 2.79048 11.8815 2.5795 11.6705C2.36853 11.4595 2.25 11.1734 2.25 10.875V7.125ZM14.25 8.625C14.25 8.004 14.754 7.5 15.375 7.5H18H20.625C21.246 7.5 21.75 8.004 21.75 8.625V16.875C21.75 17.496 21.246 18 20.625 18H15.375C15.0766 18 14.7905 17.8815 14.5795 17.6705C14.3685 17.4595 14.25 17.1734 14.25 16.875V8.625Z"
        stroke="#B1A8B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 16V19M1 17.5H4"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 2L13.5714 3.90476L15 4.5L13.5714 5.09525L13 7L12.4286 5.09525L11 4.5L12.4286 3.90476L13 2Z"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Tag: FC = () => {
  return (
    <Icon24>
      <path
        d="M6.99999 6.99999H7.00999M6.99999 3H12C12.5119 2.99999 13.0237 3.19525 13.4142 3.58579L20.4143 10.5858C21.1953 11.3668 21.1953 12.6332 20.4143 13.4142L13.4142 20.4142C12.6332 21.1953 11.3668 21.1953 10.5858 20.4142L3.58579 13.4142C3.19526 13.0237 3 12.5118 3 12V6.99999C3 4.79086 4.79086 3 6.99999 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Theme: FC = () => {
  return (
    <Icon24>
      <mask id="path-1-inside-1_2205_201" fill="white">
        <rect x="6" y="10.0859" width="6" height="6" rx="1.14286" />
      </mask>
      <rect
        x="6"
        y="10.0859"
        width="6"
        height="6"
        rx="1.14286"
        stroke="currentColor"
        strokeWidth="3"
        mask="url(#path-1-inside-1_2205_201)"
      />
      <mask id="path-2-inside-2_2205_201" fill="white">
        <rect x="13" y="10.0859" width="6" height="6" rx="1.14286" />
      </mask>
      <rect
        x="13"
        y="10.0859"
        width="6"
        height="6"
        rx="1.14286"
        stroke="currentColor"
        strokeWidth="3"
        mask="url(#path-2-inside-2_2205_201)"
      />
      <path
        d="M14 6.5L19.5 6.5C20.6046 6.5 21.5 7.39543 21.5 8.5V12.4857V17.0857C21.5 18.1903 20.6046 19.0857 19.5 19.0857H12.9641H5C3.89543 19.0857 3 18.1903 3 17.0857V7.5C3 6.94771 3.44772 6.5 4 6.5V6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <rect
        x="6.75"
        y="5.13574"
        width="4.5"
        height="2.69096"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ArrowLeft: FC = () => {
  return (
    <Icon24>
      <path
        d="M10 19L3 12M3 12L10 5M3 12H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Transcript: FC = () => {
  return (
    <Icon24>
      <path
        clipRule="evenodd"
        d="m6.704 13.868-4.335-.01c-.204-.001-.369-.155-.369-.344V6.343c0-.19.166-.343.37-.343h7.778c.205 0 .37.153.37.343v6.828C10.518 16.391 7.7 20 4.222 20c-.204 0-.37-.154-.37-.343v-2.743c0-.19.166-.343.37-.343 1.162 0 2.158-1.71 2.482-2.703Zm9 2.703c1.161 0 2.158-1.71 2.482-2.703l-4.335-.01c-.204-.001-.37-.155-.37-.344V6.343c0-.19.166-.343.37-.343h7.779c.204 0 .37.154.37.343v6.829C22 16.39 19.181 20 15.704 20c-.205 0-.37-.154-.37-.343v-2.743c0-.189.165-.343.37-.343Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Translate: FC = () => {
  return (
    <Icon24>
      <path
        d="M10.8333 21L16.0833 9.75L21.3333 21M12.3333 18H19.8333M3.33334 5.621C5.32374 5.37332 7.32759 5.24941 9.33334 5.25M9.33334 5.25C10.4533 5.25 11.5663 5.288 12.6673 5.364M9.33334 5.25V3M12.6673 5.364C11.5093 10.658 8.02334 15.08 3.33334 17.502M12.6673 5.364C13.5633 5.425 14.4523 5.511 15.3333 5.621M10.7443 14.116C9.10431 12.4486 7.80448 10.478 6.91734 8.314"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Refresh: FC = () => {
  return (
    <Icon24>
      <path
        d="M5.5 5.11829V9.49329H6.00883M6.00883 9.49329C7.04725 6.92793 9.56229 5.11829 12.5 5.11829C16.0696 5.11829 19.0153 7.79026 19.4458 11.2433M6.00883 9.49329H9.875M19.5 19.1183V14.7433H18.9912M18.9912 14.7433C17.9527 17.3086 15.4377 19.1183 12.5 19.1183C8.93033 19.1183 5.98474 16.4463 5.55415 12.9933M18.9912 14.7433H15.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Search: FC = () => {
  return (
    <Icon24>
      <path
        d="M21.5 21L15.5 15L21.5 21ZM17.5 10C17.5 13.866 14.366 17 10.5 17C6.63401 17 3.5 13.866 3.5 10C3.5 6.13401 6.63401 3 10.5 3C14.366 3 17.5 6.13401 17.5 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Person: FC = () => {
  return (
    <Icon24>
      <path
        d="M15.4669 12.3325C16.2619 11.4469 16.75 10.2806 16.75 9C16.75 6.24313 14.5069 4 11.75 4C8.99313 4 6.75 6.24313 6.75 9C6.75 11.7569 8.99313 14 11.75 14C12.7219 14 13.6269 13.7169 14.3956 13.235C17.1144 14.2594 18.9862 16.7475 19.2244 19.625H4.27625C4.43812 17.6881 5.34687 15.8819 6.825 14.5931C7.08562 14.3662 7.1125 13.9719 6.88563 13.7113C6.65938 13.4513 6.26438 13.4237 6.00375 13.6506C4.09438 15.3144 3 17.7194 3 20.25C3 20.5956 3.28 20.875 3.625 20.875H19.875C20.2206 20.875 20.5 20.5956 20.5 20.25C20.5 16.8212 18.5125 13.7594 15.4669 12.3325ZM8 9C8 6.93187 9.68187 5.25 11.75 5.25C13.8181 5.25 15.5 6.93187 15.5 9C15.5 11.0681 13.8181 12.75 11.75 12.75C9.68187 12.75 8 11.0681 8 9Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const SWOT: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.13636 4.5H11.6108V11.1108H5V7.63636C5 5.9042 6.4042 4.5 8.13636 4.5Z"
        stroke="currentColor"
      />
      <path
        d="M5 12.8892H11.6108V19.5H8.13637C6.4042 19.5 5 18.0958 5 16.3636V12.8892Z"
        stroke="currentColor"
      />
      <path
        d="M13.3892 12.8892H20V16.3636C20 18.0958 18.5958 19.5 16.8636 19.5H13.3892V12.8892Z"
        stroke="currentColor"
      />
      <path
        d="M13.3892 4.5H16.8636C18.5958 4.5 20 5.9042 20 7.63636V11.1108H13.3892V4.5Z"
        stroke="currentColor"
      />
    </Icon24>
  );
};

const UsabilityTesting: FC = () => {
  return (
    <Icon24>
      <path
        d="M18.75 17.25V19.5H5.25V12.6225L7.9425 15.3075L9 14.25L4.5 9.75L0 14.25L1.0575 15.3075L3.75 12.6225V19.5C3.75 19.8978 3.90804 20.2794 4.18934 20.5607C4.47064 20.842 4.85218 21 5.25 21H18.75C19.1478 21 19.5294 20.842 19.8107 20.5607C20.092 20.2794 20.25 19.8978 20.25 19.5V17.25H18.75Z"
        fill="currentColor"
      />
      <path
        d="M20.25 5.25V12.1275L22.9425 9.4425L24 10.5L19.5 15L15 10.5L16.0575 9.4425L18.75 12.1275V5.25H9.75V3.75H18.75C19.1478 3.75 19.5294 3.90804 19.8107 4.18934C20.092 4.47064 20.25 4.85218 20.25 5.25Z"
        fill="currentColor"
      />
      <path
        d="M6 7.5H3C2.60218 7.5 2.22064 7.34196 1.93934 7.06066C1.65804 6.77936 1.5 6.39782 1.5 6V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H6C6.39782 1.5 6.77936 1.65804 7.06066 1.93934C7.34196 2.22064 7.5 2.60218 7.5 3V6C7.5 6.39782 7.34196 6.77936 7.06066 7.06066C6.77936 7.34196 6.39782 7.5 6 7.5ZM3 3V6H6V3H3Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const FocusGroup: FC = () => {
  return (
    <Icon24>
      <path
        d="M7.5 22.5H6V20.25H3V22.5H1.5V20.25C1.50046 19.8523 1.65864 19.471 1.93984 19.1898C2.22105 18.9086 2.60232 18.7505 3 18.75H6C6.39768 18.7505 6.77895 18.9086 7.06016 19.1898C7.34136 19.471 7.49954 19.8523 7.5 20.25V22.5Z"
        fill="currentColor"
      />
      <path
        d="M22.5 22.5H21V20.25H18V22.5H16.5V20.25C16.5005 19.8523 16.6586 19.471 16.9398 19.1898C17.221 18.9086 17.6023 18.7505 18 18.75H21C21.3977 18.7505 21.779 18.9086 22.0602 19.1898C22.3414 19.471 22.4995 19.8523 22.5 20.25V22.5Z"
        fill="currentColor"
      />
      <path
        d="M15 22.5H13.5V20.25H10.5V22.5H9V20.25C9.00046 19.8523 9.15864 19.471 9.43984 19.1898C9.72105 18.9086 10.1023 18.7505 10.5 18.75H13.5C13.8977 18.7505 14.279 18.9086 14.5602 19.1898C14.8414 19.471 14.9995 19.8523 15 20.25V22.5Z"
        fill="currentColor"
      />
      <path
        d="M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
        fill="currentColor"
      />
      <path
        d="M4.5 18C5.32843 18 6 17.3284 6 16.5C6 15.6716 5.32843 15 4.5 15C3.67157 15 3 15.6716 3 16.5C3 17.3284 3.67157 18 4.5 18Z"
        fill="currentColor"
      />
      <path
        d="M19.5 18C20.3284 18 21 17.3284 21 16.5C21 15.6716 20.3284 15 19.5 15C18.6716 15 18 15.6716 18 16.5C18 17.3284 18.6716 18 19.5 18Z"
        fill="currentColor"
      />
      <path
        d="M15.75 15C16.5784 15 17.25 14.3284 17.25 13.5C17.25 12.6716 16.5784 12 15.75 12C14.9216 12 14.25 12.6716 14.25 13.5C14.25 14.3284 14.9216 15 15.75 15Z"
        fill="currentColor"
      />
      <path
        d="M8.25 15C9.07843 15 9.75 14.3284 9.75 13.5C9.75 12.6716 9.07843 12 8.25 12C7.42157 12 6.75 12.6716 6.75 13.5C6.75 14.3284 7.42157 15 8.25 15Z"
        fill="currentColor"
      />
      <path
        d="M19.5 10.5H4.5C4.10232 10.4995 3.72105 10.3414 3.43984 10.0602C3.15864 9.77895 3.00046 9.39768 3 9V3C3.00046 2.60232 3.15864 2.22105 3.43984 1.93984C3.72105 1.65864 4.10232 1.50046 4.5 1.5H19.5C19.8977 1.50046 20.279 1.65864 20.5602 1.93984C20.8414 2.22105 20.9995 2.60232 21 3V9C20.9995 9.39768 20.8414 9.77895 20.5602 10.0602C20.279 10.3414 19.8977 10.4995 19.5 10.5ZM4.5 3V9H19.5V3H4.5Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const LightBulb: FC = () => {
  return (
    <Icon24>
      <path
        d="M9.66348 17H14.3364M11.9999 3V4M18.3639 5.63603L17.6568 6.34316M21 11.9999H20M4 11.9999H3M6.34308 6.34316L5.63599 5.63603M8.46443 15.5356C6.51178 13.5829 6.51178 10.4171 8.46443 8.46451C10.417 6.51186 13.5829 6.51186 15.5355 8.46451C17.4881 10.4171 17.4881 13.5829 15.5355 15.5356L14.9884 16.0827C14.3555 16.7155 13.9999 17.5739 13.9999 18.469V19C13.9999 20.1046 13.1045 21 11.9999 21C10.8954 21 9.99993 20.1046 9.99993 19V18.469C9.99993 17.5739 9.6444 16.7155 9.0115 16.0827L8.46443 15.5356Z"
        stroke="currentColor"
        strokeWidth="1.52616"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const QuestionMark: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.22766 9C8.77678 7.83481 10.2584 7 12.0001 7C14.2092 7 16.0001 8.34315 16.0001 10C16.0001 11.3994 14.7224 12.5751 12.9943 12.9066C12.4519 13.0106 12.0001 13.4477 12.0001 14M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Highlight: FC = () => {
  return (
    <Icon24>
      <path
        d="M17.9697 17.7162H1.59766L3.97903 15.3403"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.3574 1.23047L18.0789 4.95197L7.88645 15.1444L4.16496 15.1444L4.16496 11.4229L14.3574 1.23047Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4.0127 11.3506C4.0127 11.3506 5.41377 11.3505 6.51987 12.454C7.62597 13.5575 7.62597 14.9552 7.62597 14.9552"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </Icon24>
  );
};

const AIStar: FC = () => {
  return (
    <Icon24>
      <path
        d="M11.25 6.75H21.25M15 12H21.25M11.25 17.25H21.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6L8.42856 10.5714L12 12L8.42856 13.4286L7 18L5.57144 13.4286L2 12L5.57144 10.5714L7 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const AIStarHighlights: FC = () => {
  return (
    <Icon24>
      <path
        d="M6 6.32608L7.42856 10.8975L11 12.3261L7.42856 13.7547L6 18.3261L4.57144 13.7547L1 12.3261L4.57144 10.8975L6 6.32608Z"
        stroke="url(#paint0_linear_36_6)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6.82608H16.25M15.75 12.3261H22M12 17.5761H22"
        stroke="url(#paint1_linear_36_6)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.47 5V9.17391M18.55 7.08696H22.39"
        stroke="#8E84EE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_36_6"
          x1="6"
          y1="6.32608"
          x2="6"
          y2="16.3261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E84EE" />
          <stop offset="1" stopColor="#514B88" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_36_6"
          x1="20.75"
          y1="9.82608"
          x2="15.75"
          y2="12.3261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const Upload: FC = () => {
  return (
    <Icon24>
      <path
        d="M4 16V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V16M16 8L12 4M12 4L8 8M12 4V16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ThumbUp: FC = () => {
  return (
    <Icon24>
      <path
        d="M14.0556 10.2274H17.7608C18.9172 10.2274 19.6693 11.4443 19.1522 12.4786L16.43 17.923C16.1664 18.4501 15.6278 18.783 15.0386 18.783H11.9137C11.7865 18.783 11.6598 18.7673 11.5364 18.7365L8.61111 18.0052M14.0556 10.2274V6.33851C14.0556 5.4794 13.3591 4.78296 12.5 4.78296H12.4257C12.0372 4.78296 11.7222 5.09794 11.7222 5.48648C11.7222 6.04205 11.5578 6.58519 11.2496 7.04745L8.61111 11.0052V18.0052M14.0556 10.2274H12.5M8.61111 18.0052H7.05556C6.19645 18.0052 5.5 17.3088 5.5 16.4496V11.783C5.5 10.9238 6.19645 10.2274 7.05556 10.2274H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Heart: FC<{ active?: boolean }> = ({ active }) => {
  return (
    <Icon24>
      <path
        d="M4.31802 6.31802C2.56066 8.07538 2.56066 10.9246 4.31802 12.682L12.0001 20.364L19.682 12.682C21.4393 10.9246 21.4393 8.07538 19.682 6.31802C17.9246 4.56066 15.0754 4.56066 13.318 6.31802L12.0001 7.63609L10.682 6.31802C8.92462 4.56066 6.07538 4.56066 4.31802 6.31802Z"
        stroke="currentColor"
        fill={active ? 'currentColor' : 'none'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const GoogleDriveIcon: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#a)">
        <path
          d="m2.024 16.102.912 1.577c.19.332.463.593.783.782l3.26-5.642H.459c0 .367.095.735.284 1.067l1.28 2.216Z"
          fill="#0066DA"
        />
        <path
          d="M10.807 6.181 7.547.539c-.32.19-.592.45-.782.782L.743 11.752A2.148 2.148 0 0 0 .46 12.82h6.52l3.828-6.638Z"
          fill="#00AC47"
        />
        <path
          d="M17.896 18.461c.32-.19.593-.45.782-.782l.38-.652 1.813-3.141c.19-.332.285-.7.285-1.067h-6.52l1.387 2.726 1.873 2.916Z"
          fill="#EA4335"
        />
        <path
          d="m10.807 6.18 3.26-5.642A2.084 2.084 0 0 0 13 .254H8.614c-.38 0-.747.107-1.067.284l3.26 5.643Z"
          fill="#00832D"
        />
        <path
          d="M14.636 12.819H6.98l-3.26 5.642c.32.19.687.285 1.067.285h12.043c.38 0 .747-.107 1.067-.285l-3.26-5.642Z"
          fill="#2684FC"
        />
        <path
          d="M17.86 6.537 14.85 1.32a2.153 2.153 0 0 0-.783-.782l-3.26 5.642 3.83 6.638h6.507c0-.367-.095-.735-.284-1.067l-3-5.215Z"
          fill="#FFBA00"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(.645 .254)" d="M0 0h20.711v18.492H0z" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const OneDriveIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <Icon24 {...props}>
      <g id="STYLE_COLOR">
        <path
          d="M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z"
          fill="#0364b8"
        />
        <path
          d="M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z"
          fill="#0078d4"
        />
        <path
          d="M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z"
          fill="#1490df"
        />
        <path
          d="M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z"
          fill="#28a8ea"
        />
      </g>
    </Icon24>
  );
};

const Dots: FC = () => {
  return (
    <Icon24>
      <path
        d="M5 12H5.01H5ZM12 12H12.01H12ZM19 12H19.01H19ZM6 12C6 12.5523 5.55228 13 5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 11.4477 6 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM20 12C20 12.5523 19.5523 13 19 13C18.4477 13 18 12.5523 18 12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const DotsVertical: FC = () => {
  return (
    <Icon24>
      <path
        d="M12 19V18.99M12 12V11.99M12 5V4.99M12 18C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18ZM12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11ZM12 4C12.5523 4 13 4.4477 13 5C13 5.5523 12.5523 6 12 6C11.4477 6 11 5.5523 11 5C11 4.4477 11.4477 4 12 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ChevronDown: FC = () => {
  return (
    <Icon24>
      <path
        d="M17 10L12 15L7 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};
const ChevronBack: FC = () => {
  return (
    <Icon24>
      <path
        d="M15 19L8 12L15 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Maximaize: FC = () => {
  return (
    <Icon24>
      <path
        d="M3.75 3.75V8.25M3.75 3.75H8.25M3.75 3.75L9 9M3.75 20.25V15.75M3.75 20.25H8.25M3.75 20.25L9 15M20.25 3.75H15.75M20.25 3.75V8.25M20.25 3.75L15 9M20.25 20.25H15.75M20.25 20.25V15.75M20.25 20.25L15 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Smile: FC = () => {
  return (
    <Icon24>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12.0005 16.5C9.90367 16.5 8.14181 15.0659 7.64226 13.125H9.21856C9.6636 14.2244 10.7415 15 12.0005 15C13.2595 15 14.3374 14.2244 14.7824 13.125H16.3587C15.8592 15.0659 14.0973 16.5 12.0005 16.5ZM15.9375 9.89062C15.9375 10.4343 15.4968 10.875 14.9531 10.875C14.4095 10.875 13.9688 10.4343 13.9688 9.89062C13.9688 9.34697 14.4095 8.90625 14.9531 8.90625C15.4968 8.90625 15.9375 9.34697 15.9375 9.89062ZM8.76562 10.875C9.30928 10.875 9.75 10.4343 9.75 9.89062C9.75 9.34697 9.30928 8.90625 8.76562 8.90625C8.22197 8.90625 7.78125 9.34697 7.78125 9.89062C7.78125 10.4343 8.22197 10.875 8.76562 10.875Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const Folder: FC = () => {
  return (
    <Icon24>
      <path
        d="M3.33331 7V17C3.33331 18.1046 4.22874 19 5.33331 19H19.3333C20.4379 19 21.3333 18.1046 21.3333 17V9C21.3333 7.89543 20.4379 7 19.3333 7H13.3333L11.3333 5H5.33331C4.22874 5 3.33331 5.89543 3.33331 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const ChevronBold: FC = () => {
  return (
    <Icon24>
      <path
        d="M6.31659 9.34775C6.75259 8.90175 7.35959 8.86675 7.89259 9.34775L11.8006 13.0947L15.7086 9.34775C16.2416 8.86675 16.8496 8.90175 17.2826 9.34775C17.7186 9.79275 17.6906 10.5447 17.2826 10.9627C16.8766 11.3807 12.5876 15.4647 12.5876 15.4647C12.3706 15.6877 12.0856 15.7997 11.8006 15.7997C11.5156 15.7997 11.2306 15.6877 11.0116 15.4647C11.0116 15.4647 6.72459 11.3807 6.31659 10.9627C5.90859 10.5447 5.88059 9.79275 6.31659 9.34775Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const Filter: FC = () => {
  return (
    <Icon24>
      <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M6 12L18 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M10 18L14 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </Icon24>
  );
};

const Eye: FC = () => {
  return (
    <Icon24>
      <path
        d="M14.9998 12C14.9998 13.6569 13.6566 15 11.9998 15C10.3429 15 8.99976 13.6569 8.99976 12C8.99976 10.3431 10.3429 9 11.9998 9C13.6566 9 14.9998 10.3431 14.9998 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.45801 12C3.73228 7.94288 7.52257 5 12.0002 5C16.4778 5 20.2681 7.94291 21.5424 12C20.2681 16.0571 16.4778 19 12.0002 19C7.52256 19 3.73226 16.0571 2.45801 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const EyeCrossed: FC = () => {
  return (
    <Icon24>
      <path
        d="M14.3749 19.1996C13.7677 19.3148 13.1411 19.375 12.5005 19.375C8.02281 19.375 4.23251 16.4321 2.95825 12.375C3.30515 11.2705 3.83851 10.2486 4.52143 9.34618M10.3787 10.2537C10.9216 9.71079 11.6716 9.375 12.5 9.375C14.1569 9.375 15.5 10.7181 15.5 12.375C15.5 13.2034 15.1642 13.9534 14.6213 14.4963M10.3787 10.2537L14.6213 14.4963M10.3787 10.2537L7.08916 6.96416M14.6213 14.4963L17.9112 17.7862M7.08916 6.96416L3.5 3.375M7.08916 6.96416C8.64898 5.95854 10.5066 5.375 12.5004 5.375C16.9781 5.375 20.7684 8.31791 22.0426 12.375C21.3357 14.6257 19.8545 16.5335 17.9112 17.7862M17.9112 17.7862L21.5 21.375"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const AtSign: FC = () => {
  return (
    <Icon24>
      <path
        d="M16.75 12C16.75 9.79086 14.9591 8 12.75 8C10.5409 8 8.75 9.79086 8.75 12C8.75 14.2091 10.5409 16 12.75 16C14.9591 16 16.75 14.2091 16.75 12ZM16.75 12V13.5C16.75 14.8807 17.8693 16 19.25 16C20.6307 16 21.75 14.8807 21.75 13.5V12C21.75 7.02944 17.7206 3 12.75 3C7.77944 3 3.75 7.02944 3.75 12C3.75 16.9706 7.77944 21 12.75 21M17.25 19.7942C15.8301 20.614 14.2796 21.0029 12.75 21.0015"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Comment: FC = () => {
  return (
    <Icon24>
      <path
        d="M21.25 12C21.25 16.4183 17.2206 20 12.25 20C10.7107 20 9.26172 19.6565 7.99467 19.0511L3.25 20L4.64499 16.28C3.76156 15.0423 3.25 13.5743 3.25 12C3.25 7.58172 7.27944 4 12.25 4C17.2206 4 21.25 7.58172 21.25 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Chat: FC = () => {
  return (
    <Icon24>
      <path
        id="Vector"
        d="M21 12.375C21 16.7933 16.9706 20.375 12 20.375C10.4607 20.375 9.01172 20.0315 7.74467 19.4261L3 20.375L4.39499 16.655C3.51156 15.4173 3 13.9493 3 12.375C3 7.95672 7.02944 4.375 12 4.375C16.9706 4.375 21 7.95672 21 12.375Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const AddEmoji: FC = () => {
  return (
    <Icon24>
      <path
        d="M15.3284 15.0159C13.7663 16.578 11.2337 16.578 9.67157 15.0159M9.5 10.1875H9.51M15.5 10.1875H15.51M21.5 12.1875C21.5 17.1581 17.4706 21.1875 12.5 21.1875C7.52944 21.1875 3.5 17.1581 3.5 12.1875C3.5 7.21694 7.52944 3.1875 12.5 3.1875"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2998 2V5.5M19.2998 5.5V9M19.2998 5.5H22.7998M19.2998 5.5H15.7998"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const HighlightAll: FC = () => {
  return (
    <Icon24>
      <path
        d="M20.372 21.4858H4L6.38137 19.1099"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7598 5L20.4813 8.7215L10.2889 18.9139H6.56738V15.1924L16.7598 5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.41504 15.1201C6.41504 15.1201 7.81611 15.12 8.92221 16.2235C10.0283 17.327 10.0283 18.7247 10.0283 18.7247"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M20 14V18M18 16H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 2L7.14285 5.42857L10 6.5L7.14285 7.57145L6 11L4.85715 7.57145L2 6.5L4.85715 5.42857L6 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Clock: FC = () => {
  return (
    <Icon24>
      <path
        d="M12 6V12H16.5M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Document: FC = () => {
  return (
    <Icon24>
      <path
        d="M9.55556 12H14.8889H9.55556ZM9.55556 15.5556H14.8889H9.55556ZM16.6667 20H7.77778C6.79594 20 6 19.2041 6 18.2222V5.77778C6 4.79594 6.79594 4 7.77778 4H12.7429C12.9787 4 13.2048 4.09365 13.3715 4.26035L18.1841 9.07299C18.3508 9.23968 18.4444 9.46578 18.4444 9.70152V18.2222C18.4444 19.2041 17.6485 20 16.6667 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Folders: FC = () => {
  return (
    <Icon24>
      <path
        d="M18.2222 11.1111H5.77778M18.2222 11.1111C19.2041 11.1111 20 11.907 20 12.8889V18.2222C20 19.2041 19.2041 20 18.2222 20H5.77778C4.79594 20 4 19.2041 4 18.2222V12.8889C4 11.907 4.79594 11.1111 5.77778 11.1111M18.2222 11.1111V9.33333C18.2222 8.35149 17.4263 7.55556 16.4444 7.55556M5.77778 11.1111V9.33333C5.77778 8.35149 6.57372 7.55556 7.55556 7.55556M16.4444 7.55556V5.77778C16.4444 4.79594 15.6485 4 14.6667 4H9.33333C8.35149 4 7.55556 4.79594 7.55556 5.77778V7.55556M16.4444 7.55556H7.55556"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Participant: FC = () => {
  return (
    <Icon24>
      <path
        d="M16.0833 7.66667C16.0833 9.69171 14.4417 11.3333 12.4167 11.3333C10.3916 11.3333 8.75 9.69171 8.75 7.66667C8.75 5.64162 10.3916 4 12.4167 4C14.4417 4 16.0833 5.64162 16.0833 7.66667Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4167 14.0835C8.87284 14.0835 6 16.9563 6 20.5002H18.8333C18.8333 16.9563 15.9605 14.0835 12.4167 14.0835Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Miro: FC = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="26" height="26" rx="6" fill="#FFD02F" />
      <path
        d="M16.7081 5H14.3665L16.3168 8.42722L12.0249 5H9.68324L11.8292 9.19093L7.34162 5H5L7.34162 10.3333L5 21H7.34162L11.8292 9.56962L9.68324 21H12.0249L16.3168 8.81223L14.3665 21H16.7081L21 7.66351L16.7081 5Z"
        fill="#050038"
      />
    </svg>
  );
};

const Spreadsheet: FC = () => {
  return (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="26" height="27" rx="6" fill="#EFEDF1" />
      <path
        d="M5.42308 19H19.5769M5.42308 19C5.17826 19 4.94347 18.9052 4.77036 18.7364C4.59725 18.5676 4.5 18.3387 4.5 18.1M5.42308 19H11.5769M19.5769 19C20.0865 19 20.5 18.5968 20.5 18.1M19.5769 19H13.4231C13.1783 19 12.9435 18.9052 12.7704 18.7364V10M4.5 18.1V7.9M4.5 18.1V16.9M4.5 7.9C4.5 7.4032 4.91354 7 5.42308 7H19.5769C20.0865 7 20.5 7.4032 20.5 7.9M4.5 7.9V9.1C4.5 9.5968 4.91354 10 5.42308 10M20.5 18.1V7.9M20.5 18.1V16.9M20.5 7.9V9.1C20.5 9.5968 20.0865 10 19.5769 10M19.5769 10H13.4231M19.5769 10C20.0865 10 20.5 10.4032 20.5 10.9V12.1M19.5769 10H12.7704M5.42308 10H11.5769M5.42308 10C4.91354 10 4.5 10.4032 4.5 10.9V12.1M5.42308 10H12.7704M4.5 13.9V15.1M20.5 13.9V15.1"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Canvas: FC = () => {
  return (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="26" height="27" rx="6" fill="#EFEDF1" />
      <path
        d="M3 7.125C3 6.504 3.504 6 4.125 6H10.125C10.746 6 11.25 6.504 11.25 7.125V10.875C11.25 11.496 10.746 12 10.125 12H4.125C3.82663 12 3.54048 11.8815 3.3295 11.6705C3.11853 11.4595 3 11.1734 3 10.875V7.125ZM15 8.625C15 8.004 15.504 7.5 16.125 7.5H21.375C21.996 7.5 22.5 8.004 22.5 8.625V16.875C22.5 17.496 21.996 18 21.375 18H16.125C15.8266 18 15.5405 17.8815 15.3295 17.6705C15.1185 17.4595 15 17.1734 15 16.875V8.625ZM4.5 16.125C4.5 15.504 5.004 15 5.625 15H10.875C11.496 15 12 15.504 12 16.125V18.375C12 18.996 11.496 19.5 10.875 19.5H5.625C5.32663 19.5 5.04048 19.3815 4.8295 19.1705C4.61853 18.9595 4.5 18.6734 4.5 18.375V16.125Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Broomstick: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_6983_68186)">
        <path
          d="M4 3L4.57142 4.90476L6 5.5L4.57142 6.09525L4 8L3.42858 6.09525L2 5.5L3.42858 4.90476L4 3Z"
          stroke="url(#paint0_linear_6983_68186)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.15369 13.8168L7.57614 9.81875L13.6371 15.8797L9.63897 22.3021C8.98503 21.9459 7.13167 20.688 4.94974 18.5061C2.76781 16.3241 1.5099 14.4708 1.15369 13.8168Z"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect
          x="11.3137"
          y="9.31372"
          width="4"
          height="3"
          transform="rotate(45 11.3137 9.31372)"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect
          x="19.0919"
          y="2.94971"
          width="2"
          height="10"
          transform="rotate(45 19.0919 2.94971)"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M16.9705 5.07104L18.3847 6.48526"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M7.48708 14.1804C7.83173 13.9506 7.92486 13.485 7.6951 13.1403C7.46533 12.7957 6.99968 12.7025 6.65503 12.9323L7.48708 14.1804ZM6.65503 12.9323L2.41239 15.7607L3.24444 17.0088L7.48708 14.1804L6.65503 12.9323Z"
          fill="#B1A8B9"
        />
        <path
          d="M9.27542 15.9688C9.50519 15.6241 9.97084 15.531 10.3155 15.7608C10.6601 15.9905 10.7533 16.4562 10.5235 16.8008L9.27542 15.9688ZM10.5235 16.8008L7.69507 21.0435L6.447 20.2114L9.27542 15.9688L10.5235 16.8008Z"
          fill="#B1A8B9"
        />
        <path
          d="M4.94971 18.506L7.77814 15.6776"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 14L19.5 17.4286L22 18.5L19.5 19.5714L18.5 23L17.5 19.5714L15 18.5L17.5 17.4286L18.5 14Z"
          stroke="url(#paint1_linear_6983_68186)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6983_68186"
          x1="4"
          y1="3"
          x2="4"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6983_68186"
          x1="18.5"
          y1="14"
          x2="18.5"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
        <clipPath id="clip0_6983_68186">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const Play: FC = () => {
  return (
    <Icon24>
      <path d="M5 20L12 16V8L5 4V20ZM12 16L19 12L12 8V16Z" fill="currentColor" />
    </Icon24>
  );
};

const Pause: FC = () => {
  return (
    <Icon24>
      <line x1="8.5" y1="4" x2="8.5" y2="20" stroke="currentColor" strokeWidth="3" />
      <line x1="15.5" y1="4" x2="15.5" y2="20" stroke="currentColor" strokeWidth="3" />
    </Icon24>
  );
};

const Brackets: FC = () => {
  return (
    <Icon24>
      <line x1="15" y1="4" x2="20" y2="4" stroke="currentColor" strokeWidth="2" />
      <line x1="15" y1="20" x2="20" y2="20" stroke="currentColor" strokeWidth="2" />
      <line x1="21.0001" y1="3" x2="21.0001" y2="21" stroke="currentColor" strokeWidth="2" />
      <line x1="9" y1="20" x2="4" y2="20" stroke="currentColor" strokeWidth="2" />
      <line x1="9" y1="4" x2="4" y2="4" stroke="currentColor" strokeWidth="2" />
      <line x1="3" y1="21" x2="3" y2="3" stroke="currentColor" strokeWidth="2" />
    </Icon24>
  );
};

const Speaker: FC = () => {
  return (
    <Icon24>
      <path
        d="M3 15.0834H7.10651L12.2396 20.2165V3.7905L7.10651 8.92364H3V15.0834ZM14.2929 7.89701V16.11C15.8123 15.4119 16.8595 13.8206 16.8595 12.0035C16.8595 10.2172 15.8123 8.65671 14.2929 7.89701ZM14.2929 5.11485C17.2598 5.99775 19.426 8.74911 19.426 12.0035C19.426 15.2579 17.2598 18.0093 14.2929 18.8922V21.007C18.4097 20.0728 21.4793 16.3975 21.4793 12.0035C21.4793 7.60955 18.4097 3.93423 14.2929 3V5.11485Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const SpeakerMute: FC = () => {
  return (
    <Icon24>
      <path
        d="M3 15.0834H7.10651L12.2396 20.2165V3.7905L7.10651 8.92364H3V15.0834ZM14.2929 7.89701V16.11C15.8123 15.4119 16.8595 13.8206 16.8595 12.0035C16.8595 10.2172 15.8123 8.65671 14.2929 7.89701ZM14.2929 5.11485C17.2598 5.99775 19.426 8.74911 19.426 12.0035C19.426 15.2579 17.2598 18.0093 14.2929 18.8922V21.007C18.4097 20.0728 21.4793 16.3975 21.4793 12.0035C21.4793 7.60955 18.4097 3.93423 14.2929 3V5.11485Z"
        fill="currentColor"
      />
      <path
        d="M4.28331 2.76414L2.97949 4.06796L20.155 21.2434L21.4588 19.9396L4.28331 2.76414Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

const Scissors: FC = () => {
  return (
    <Icon24>
      <path
        d="M7.60795 8.48277L9.14395 9.36977M7.60795 8.48277C7.4124 8.82671 7.15076 9.12857 6.83807 9.37098C6.52539 9.61338 6.16785 9.79154 5.78603 9.8952C5.40421 9.99886 5.00566 10.026 4.61332 9.97498C4.22098 9.92399 3.8426 9.79589 3.49997 9.59806C3.15734 9.40024 2.85722 9.1366 2.61689 8.82231C2.37657 8.50803 2.20078 8.14931 2.09965 7.76681C1.99853 7.38431 1.97406 6.98559 2.02766 6.5936C2.08125 6.20161 2.21186 5.82409 2.41195 5.48277C2.8126 4.79935 3.46731 4.30215 4.23319 4.09966C4.99908 3.89717 5.81397 4.00584 6.50003 4.40195C7.1861 4.79806 7.68763 5.44945 7.8952 6.21398C8.10276 6.97851 7.9995 7.7941 7.60795 8.48277ZM9.14395 9.36977C9.46794 9.55665 9.738 9.82427 9.9278 10.1466C10.1176 10.4688 10.2207 10.8348 10.227 11.2088C10.232 11.5598 10.281 11.9038 10.367 12.2328M9.14395 9.36977L11.221 10.5688M10.367 12.2328C10.281 12.5628 10.232 12.9058 10.227 13.2578C10.2205 13.6316 10.1173 13.9973 9.92755 14.3194C9.73776 14.6415 9.4678 14.909 9.14395 15.0958M10.367 12.2328C10.527 11.6225 10.8185 11.0546 11.221 10.5688M11.221 10.5688C11.7604 9.91657 12.4795 9.43708 13.289 9.18977L18.614 7.56177C19.4202 7.31507 20.2795 7.29982 21.094 7.51777L21.8969 7.73277L14.103 12.2328M7.60795 15.9828L9.14395 15.0958M7.60795 15.9828C7.80804 16.3241 7.93865 16.7016 7.99225 17.0936C8.04584 17.4856 8.02137 17.8843 7.92025 18.2668C7.81912 18.6493 7.64333 19.008 7.40301 19.3223C7.16268 19.6366 6.86257 19.9002 6.51993 20.0981C6.1773 20.2959 5.79892 20.424 5.40658 20.475C5.01424 20.526 4.61569 20.4989 4.23387 20.3952C3.85205 20.2915 3.49451 20.1134 3.18183 19.871C2.86914 19.6286 2.6075 19.3267 2.41195 18.9828C2.0204 18.2941 1.91714 17.4785 2.1247 16.714C2.33227 15.9495 2.83381 15.2981 3.51987 14.9019C4.20593 14.5058 5.02082 14.3972 5.78671 14.5997C6.55259 14.8021 7.2073 15.2994 7.60795 15.9828ZM9.14395 15.0958L11.221 13.8968M11.221 13.8968C11.7605 14.5489 12.4795 15.0284 13.289 15.2758L18.615 16.9048C19.4213 17.1512 20.2806 17.166 21.0949 16.9478L21.8969 16.7328L14.103 12.2328M11.221 13.8968L14.103 12.2328"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const SmartTemplate: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.5 8L9.49999 11.4286L12 12.5L9.49999 13.5714L8.5 17L7.50001 13.5714L5 12.5L7.50001 11.4286L8.5 8Z"
        stroke="url(#paint0_linear_108_2442)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 4L16.5714 5.90476L18 6.5L16.5714 7.09525L16 9L15.4286 7.09525L14 6.5L15.4286 5.90476L16 4Z"
        stroke="url(#paint1_linear_108_2442)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13L16.5714 14.9048L18 15.5L16.5714 16.0953L16 18L15.4286 16.0953L14 15.5L15.4286 14.9048L16 13Z"
        stroke="url(#paint2_linear_108_2442)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_108_2442"
          x1="8.5"
          y1="8"
          x2="8.5"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_108_2442"
          x1="16"
          y1="4"
          x2="16"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_108_2442"
          x1="16"
          y1="13"
          x2="16"
          y2="16.0556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const SmartStars: FC = () => {
  return (
    <Icon24>
      <path
        d="M9.5 9L10.5 12.4286L13 13.5L10.5 14.5714L9.5 18L8.50001 14.5714L6 13.5L8.50001 12.4286L9.5 9Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 5L17.5714 6.90476L19 7.5L17.5714 8.09525L17 10L16.4286 8.09525L15 7.5L16.4286 6.90476L17 5Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14L17.5714 15.9048L19 16.5L17.5714 17.0953L17 19L16.4286 17.0953L15 16.5L16.4286 15.9048L17 14Z"
        stroke="currentColor"
        strokeOpacity="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const SmartStarsBold: FC = () => {
  return (
    <Icon24>
      <path
        d="M9.5 9L10.5 12.4286L13 13.5L10.5 14.5714L9.5 18L8.50001 14.5714L6 13.5L8.50001 12.4286L9.5 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 5L17.5714 6.90476L19 7.5L17.5714 8.09525L17 10L16.4286 8.09525L15 7.5L16.4286 6.90476L17 5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14L17.5714 15.9048L19 16.5L17.5714 17.0953L17 19L16.4286 17.0953L15 16.5L16.4286 15.9048L17 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const PostySmall: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_39_8)">
        <path
          d="M10.2619 5.54346H16.9457C18.2587 5.54346 19.5249 6.03107 20.4987 6.91172L21.5661 7.87702C22.0736 8.33595 22.3523 8.99569 22.3277 9.67946L22.1761 13.8806C22.0276 17.9929 18.6509 21.2499 14.5359 21.2499L8.3 21.2499V21.2499C6.01734 21.2499 4.16687 19.3995 4.16687 17.1168V15.6732V14.1442"
          stroke="currentColor"
          strokeWidth="1.2264"
        />
        <path
          d="M4.78271 18.75H8.1979L13.1667 18.75C17.6667 18.75 19.6667 15.5465 19.6667 12.75V6.24998"
          stroke="currentColor"
          strokeWidth="1.2264"
        />
        <path
          d="M7.99597 10.9254C7.99597 10.9254 8.29515 11.6274 9.27 11.6274C10.2449 11.6274 10.5698 10.9254 10.5698 10.9254"
          stroke="currentColor"
          strokeWidth="1.2264"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M13.1438 10.9254C13.1438 10.9254 13.443 11.6274 14.4178 11.6274C15.3927 11.6274 15.7176 10.9254 15.7176 10.9254"
          stroke="currentColor"
          strokeWidth="1.2264"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M8.69788 13.4987C8.69788 13.4987 9.45943 15.3706 11.9409 15.3706C14.4223 15.3706 15.2494 13.4987 15.2494 13.4987"
          stroke="currentColor"
          strokeWidth="1.2264"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M4.16675 4.25L5.16674 7.29762L7.66675 8.25L5.16674 9.2024L4.16675 12.25L3.16675 9.2024L0.666748 8.25L3.16675 7.29762L4.16675 4.25Z"
          stroke="url(#paint0_linear_39_8)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.01915 0.75L8.69126 2.54231L10.3716 3.1024L8.69126 3.66251L8.01915 5.4548L7.34704 3.66251L5.66675 3.1024L7.34704 2.54231L8.01915 0.75Z"
          fill="url(#paint1_linear_39_8)"
          stroke="url(#paint2_linear_39_8)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_39_8"
          x1="4.16675"
          y1="4.25"
          x2="4.16675"
          y2="12.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_39_8"
          x1="8.01915"
          y1="0.75"
          x2="8.01915"
          y2="5.4548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#8F84EF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_39_8"
          x1="8.01915"
          y1="0.75"
          x2="8.01915"
          y2="5.4548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
        <clipPath id="clip0_39_8">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const PostyGray: FC = () => {
  return (
    <Icon24>
      <path
        d="M10.4936 5.54346H17.1774C18.4904 5.54346 19.7565 6.03107 20.7304 6.91172L21.7978 7.87702C22.3053 8.33595 22.584 8.99569 22.5593 9.67946L22.4077 13.8806C22.2593 17.9929 18.8826 21.2499 14.7676 21.2499L8.53169 21.2499V21.2499C6.24903 21.2499 4.39856 19.3995 4.39856 17.1168V15.6732V14.1442"
        stroke="#B1A8B9"
        strokeWidth="1.2264"
      />
      <path
        d="M5.0144 18.75H8.42959L13.3984 18.75C17.8984 18.75 19.8984 15.5465 19.8984 12.75V6.24998"
        stroke="#B1A8B9"
        strokeWidth="1.2264"
      />
      <path
        d="M8.22766 10.9254C8.22766 10.9254 8.52684 11.6274 9.50169 11.6274C10.4765 11.6274 10.8015 10.9254 10.8015 10.9254"
        stroke="#B1A8B9"
        strokeWidth="1.2264"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.3755 10.9254C13.3755 10.9254 13.6747 11.6274 14.6495 11.6274C15.6244 11.6274 15.9493 10.9254 15.9493 10.9254"
        stroke="#B1A8B9"
        strokeWidth="1.2264"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.92957 13.4987C8.92957 13.4987 9.69112 15.3706 12.1726 15.3706C14.654 15.3706 15.4811 13.4987 15.4811 13.4987"
        stroke="#B1A8B9"
        strokeWidth="1.2264"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.6"
        d="M4.5 4.5L5.49999 7.54762L8 8.5L5.49999 9.4524L4.5 12.5L3.50001 9.4524L1 8.5L3.50001 7.54762L4.5 4.5Z"
        stroke="url(#paint0_linear_40_30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.6"
        d="M8.3524 1L9.02451 2.79231L10.7048 3.3524L9.02451 3.91251L8.3524 5.7048L7.68029 3.91251L6 3.3524L7.68029 2.79231L8.3524 1Z"
        stroke="url(#paint1_linear_40_30)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_40_30"
          x1="4.5"
          y1="4.5"
          x2="4.5"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2A9BA" />
          <stop offset="1" stopColor="#D7D3DC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_40_30"
          x1="8.3524"
          y1="1"
          x2="8.3524"
          y2="5.7048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1A8B9" />
          <stop offset="1" stopColor="#D7D3DC" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const PostyPen: FC = () => {
  return (
    <Icon24>
      <path
        d="M20.372 20.4858H4L6.38137 18.1099"
        stroke="url(#paint0_linear_55_69)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7598 4L20.4813 7.7215L10.2889 17.9139H6.56738V14.1924L16.7598 4Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6.41504 14.1201C6.41504 14.1201 7.81611 14.12 8.92221 15.2235C10.0283 16.327 10.0283 17.7247 10.0283 17.7247"
        stroke="#3B2651"
        strokeWidth="1.5"
      />
      <path
        d="M20.25 13V17M18.25 15H22.25"
        stroke="#8E84EE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 2L6.89285 5.42857L9.75 6.5L6.89285 7.57145L5.75 11L4.60715 7.57145L1.75 6.5L4.60715 5.42857L5.75 2Z"
        stroke="url(#paint1_linear_55_69)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_55_69"
          x1="4"
          y1="19.2978"
          x2="20.372"
          y2="19.2978"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.16" stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_55_69"
          x1="5.75"
          y1="2"
          x2="5.75"
          y2="7.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const PostyPenGray: FC = () => {
  return (
    <Icon24>
      <path
        d="M21.122 20.7265H4.75L7.13137 18.3506"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5098 4.24072L21.2313 7.96222L11.0389 18.1547H7.31738V14.4332L17.5098 4.24072Z"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M7.16504 14.3608C7.16504 14.3608 8.56611 14.3607 9.67221 15.4642C10.7783 16.5677 10.7783 17.9654 10.7783 17.9654"
        stroke="#D7D3DC"
        strokeWidth="1.5"
      />
      <path
        d="M20.25 13.5V17.5M18.25 15.5H22.25"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 2.5L6.89285 5.92857L9.75 7L6.89285 8.07145L5.75 11.5L4.60715 8.07145L1.75 7L4.60715 5.92857L5.75 2.5Z"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const PostySend: FC = () => {
  return (
    <Icon24>
      <path
        d="M15 11.25L12 8.25M12 8.25L9 11.25M12 8.25V15.75M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
        stroke="url(#paint0_linear_6983_72232)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6983_72232"
          x1="12"
          y1="3"
          x2="12"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const PostySendGray: FC = () => {
  return (
    <Icon24>
      <path
        d="M15 11.25L12 8.25M12 8.25L9 11.25M12 8.25V15.75M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const PostyTag: FC = () => {
  return (
    <Icon24>
      <path
        d="M8.09659 6.875H8.10636M4.1875 11.2727V6.875C4.1875 4.71607 5.93766 2.96591 8.09659 2.96591H12.9829C13.4832 2.9659 13.9834 3.15672 14.365 3.53839L21.206 10.3793C21.9692 11.1425 21.9692 12.3802 21.206 13.1434L14.365 19.9843C13.6018 20.7477 12.3641 20.7477 11.6009 19.9843L10.7075 19.0909"
        stroke="#B1A8B9"
        strokeWidth="1.46591"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8011 1.98863V5.89772M18.8466 3.94318H22.7556"
        stroke="#8E84EE"
        strokeWidth="1.46591"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.40909 13.2273L6.52597 16.5779L9.31818 17.625L6.52597 18.6721L5.40909 22.0227L4.29222 18.6721L1.5 17.625L4.29222 16.5779L5.40909 13.2273Z"
        stroke="url(#paint0_linear_57_81)"
        strokeWidth="1.46591"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_57_81"
          x1="2.72159"
          y1="19.0909"
          x2="7.60796"
          y2="16.6477"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E84EE" />
          <stop offset="1" stopColor="#3B2651" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const PostySearch: FC = () => {
  return (
    <Icon24>
      <path
        d="M3.5 19V23M5.5 21H1.5"
        stroke="#8E84EE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 2L16.8571 5.42857L14 6.5L16.8571 7.57145L18 11L19.1428 7.57145L22 6.5L19.1428 5.42857L18 2Z"
        stroke="url(#paint0_linear_59_96)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 21L14 15M16 10C16 13.866 12.866 17 9 17C5.13401 17 2 13.866 2 10C2 6.13401 5.13401 3 9 3C10.3197 3 11.554 3.36518 12.6076 4"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_59_96"
          x1="18"
          y1="2"
          x2="18"
          y2="7.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B2651" />
          <stop offset="1" stopColor="#8E84EE" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const PostyQuotes: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_6993_79171)">
        <path
          d="M8.0134 13.6817L8.72518 13.918C8.80098 13.6898 8.76272 13.4391 8.62232 13.2438C8.48191 13.0486 8.25639 12.9325 8.01589 12.9317L8.0134 13.6817ZM5.54554 13.6735L5.54803 12.9235L5.5474 12.9235L5.54554 13.6735ZM16.1986 13.6817L16.9103 13.9182C16.9862 13.6899 16.9479 13.4392 16.8075 13.2439C16.6671 13.0486 16.4416 12.9325 16.2011 12.9317L16.1986 13.6817ZM13.7307 13.6735L13.7332 12.9235L13.7326 12.9235L13.7307 13.6735ZM14.1852 6.76947C14.1852 6.35525 13.8494 6.01947 13.4352 6.01947C13.021 6.01947 12.6852 6.35525 12.6852 6.76947H14.1852ZM6.88163 18.4104L7.03628 19.1443L6.88163 18.4104ZM8.01589 12.9317L5.54803 12.9235L5.54305 14.4235L8.01091 14.4317L8.01589 12.9317ZM5.5474 12.9235C5.72892 12.9239 6 13.0737 6 13.404H4.5C4.5 14.0315 5.03538 14.4222 5.54368 14.4235L5.5474 12.9235ZM6 13.404V6.76943H4.5V13.404H6ZM6 6.76943C6 7.10044 5.7281 7.25 5.54634 7.25V5.75C5.03726 5.75 4.5 6.14082 4.5 6.76943H6ZM5.54634 7.25H10.7685V5.75H5.54634V7.25ZM10.7685 7.25C10.5867 7.25 10.3148 7.10045 10.3148 6.76943H11.8148C11.8148 6.14081 11.2775 5.75 10.7685 5.75V7.25ZM10.3148 6.76943V13.1347H11.8148V6.76943H10.3148ZM6.02782 17.75C6.20988 17.75 6.48157 17.8998 6.48157 18.2305H4.98157C4.98157 18.8589 5.51843 19.25 6.02782 19.25V17.75ZM6.48157 16.0755C6.48157 16.4063 6.20988 16.5561 6.02782 16.5561V15.0561C5.51843 15.0561 4.98157 15.4472 4.98157 16.0755H6.48157ZM6.02782 16.5561C6.8489 16.5561 7.47415 15.9828 7.85693 15.5057C8.26583 14.996 8.57037 14.3842 8.72518 13.918L7.30163 13.4453C7.19742 13.7591 6.97375 14.2095 6.68691 14.567C6.37395 14.9571 6.13591 15.0561 6.02782 15.0561V16.5561ZM14.2129 16.5561C15.034 16.5561 15.6592 15.9828 16.042 15.5057C16.4509 14.9961 16.7555 14.3843 16.9103 13.9182L15.4868 13.4453C15.3826 13.7591 15.1589 14.2095 14.872 14.567C14.559 14.9571 14.321 15.0561 14.2129 15.0561V16.5561ZM16.2011 12.9317L13.7332 12.9235L13.7282 14.4235L16.1961 14.4317L16.2011 12.9317ZM13.7326 12.9235C13.914 12.924 14.1852 13.0736 14.1852 13.4041H12.6852C12.6852 14.0317 13.2208 14.4222 13.7289 14.4235L13.7326 12.9235ZM14.1852 13.4041V6.76947H12.6852V13.4041H14.1852ZM18.5 13.1348C18.5 14.189 18.0226 15.3583 17.2142 16.2675C16.409 17.1731 15.3409 17.75 14.213 17.75V19.25C15.867 19.25 17.3174 18.4089 18.3352 17.2642C19.3498 16.1231 20 14.6098 20 13.1348H18.5ZM14.213 17.75C14.3951 17.75 14.6668 17.8998 14.6668 18.2306H13.1668C13.1668 18.8589 13.7036 19.25 14.213 19.25V17.75ZM14.6668 18.2306V16.0756H13.1668V18.2306H14.6668ZM14.6668 16.0756C14.6668 16.4058 14.3955 16.5561 14.2129 16.5561V15.0561C13.7029 15.0561 13.1668 15.4478 13.1668 16.0756H14.6668ZM10.3148 13.1347C10.3148 14.0766 9.93392 15.1133 9.26951 15.9768C8.60636 16.8386 7.70577 17.4703 6.72698 17.6766L7.03628 19.1443C8.43268 18.8501 9.62368 17.9762 10.4583 16.8915C11.2917 15.8084 11.8148 14.4575 11.8148 13.1347H10.3148ZM6.72698 17.6766C6.49872 17.7247 6.26528 17.75 6.02782 17.75V19.25C6.37241 19.25 6.70949 19.2132 7.03628 19.1443L6.72698 17.6766ZM6.10602 19.2459L6.95984 19.1564L6.80342 17.6645L5.94961 17.754L6.10602 19.2459ZM6.48157 18.2305V17.153H4.98157V18.2305H6.48157ZM6.48157 17.153V16.0755H4.98157V17.153H6.48157Z"
          fill="#3B2651"
        />
        <path
          d="M19.25 1.5L20.3929 4.92857L23.25 6L20.3929 7.07145L19.25 10.5L18.1072 7.07145L15.25 6L18.1072 4.92857L19.25 1.5Z"
          stroke="url(#paint0_linear_6993_79171)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 18.5V22.5M1.25 20.5H5.25"
          stroke="#8E84EE"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6993_79171"
          x1="16.5"
          y1="7.5"
          x2="21.5"
          y2="5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E84EE" />
          <stop offset="1" stopColor="#3B2651" />
        </linearGradient>
        <clipPath id="clip0_6993_79171">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

export const PostyStars: FC = () => {
  return (
    <Icon24>
      <path
        d="M5.75 6.82605L7.17856 11.3975L10.75 12.826L7.17856 14.2547L5.75 18.8261L4.32144 14.2547L0.75 12.826L4.32144 11.3975L5.75 6.82605Z"
        stroke="url(#paint0_linear_6983_72139)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 7.32605H16M15.5 12.826H21.75M11.75 18.076H21.75"
        stroke="#B1A8B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.22 5.5V9.67391M18.3 7.58696H22.14"
        stroke="#8E84EE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6983_72139"
          x1="5.75"
          y1="6.82605"
          x2="5.75"
          y2="16.826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E84EE" />
          <stop offset="1" stopColor="#514B88" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

export const TickCircle: FC = () => {
  return (
    <Icon24>
      <path
        d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="#3B2651"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

export const Paragraph: FC = () => {
  return (
    <Icon24>
      <path
        d="M4.8 5.8H8.99999V18.4H6.59999V20.2H13.2V18.4H10.8V5.8H15V7.59999H16.8V4.9C16.8 4.6613 16.7052 4.43239 16.5364 4.2636C16.3676 4.09482 16.1387 4 15.9 4H3.9C3.6613 4 3.43239 4.09482 3.2636 4.2636C3.09482 4.43239 3 4.6613 3 4.9V7.59999H4.8V5.8Z"
        fill="#3B2651"
        fillOpacity="0.4"
      />
      <path
        d="M16.5 10.2999V12.6999H14.1V14.4999H16.5V17.4999C16.5 18.216 16.7844 18.9028 17.2908 19.4091C17.7971 19.9154 18.4839 20.1999 19.2 20.1999H21V18.3999H19.2C18.9613 18.3999 18.7324 18.3051 18.5636 18.1363C18.3948 17.9675 18.3 17.7386 18.3 17.4999V14.4999H20.7V12.6999H18.3V10.2999H16.5Z"
        fill="#3B2651"
        fillOpacity="0.4"
      />
    </Icon24>
  );
};

const Copy: FC = () => {
  return (
    <Icon24>
      <path
        d="M15.75 17.25V20.625C15.75 21.246 15.246 21.75 14.625 21.75H4.875C4.57663 21.75 4.29048 21.6315 4.0795 21.4205C3.86853 21.2095 3.75 20.9234 3.75 20.625V7.875C3.75 7.254 4.254 6.75 4.875 6.75H6.75C7.25257 6.74966 7.7543 6.79114 8.25 6.874M15.75 17.25H19.125C19.746 17.25 20.25 16.746 20.25 16.125V11.25C20.25 6.79 17.007 3.089 12.75 2.374C12.2543 2.29114 11.7526 2.24966 11.25 2.25H9.375C8.754 2.25 8.25 2.754 8.25 3.375V6.874M15.75 17.25H9.375C9.07663 17.25 8.79048 17.1315 8.5795 16.9205C8.36853 16.7095 8.25 16.4234 8.25 16.125V6.874M20.25 13.5V11.625C20.25 10.7299 19.8944 9.87145 19.2615 9.23852C18.6286 8.60558 17.7701 8.25 16.875 8.25H15.375C15.0766 8.25 14.7905 8.13148 14.5795 7.9205C14.3685 7.70952 14.25 7.42337 14.25 7.125V5.625C14.25 5.18179 14.1627 4.74292 13.9931 4.33345C13.8235 3.92397 13.5749 3.55191 13.2615 3.23852C12.9481 2.92512 12.576 2.67652 12.1666 2.50691C11.7571 2.3373 11.3182 2.25 10.875 2.25H9.75"
        stroke="#3B2651"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const PII: FC = () => {
  return (
    <Icon24>
      <path
        d="M16.2682 5.32313C15.4701 5.04267 14.7107 4.68022 14 4.24585M16.2682 5.32313L14 4.24585M16.2682 5.32313C17.1373 5.62855 18.0523 5.83674 19 5.93474M16.2682 5.32313L19 5.93474M14 4.24585C13.2797 3.80562 12.6096 3.29152 12 2.71399C9.73574 4.86422 6.72026 6.04357 3.598 5.99999C3.20084 7.20997 2.99898 8.47549 3 9.74899C3 15.341 6.824 20.039 12 21.372C13.0643 21.0981 14.0715 20.6819 15 20.1448C15.1693 20.0469 15.336 19.9449 15.5 19.8391M19 5.93474C19.4109 5.97722 19.8279 5.99899 20.25 5.99899H20.402C20.79 7.17899 21 8.43999 21 9.74999C21 11.3039 20.7047 12.7888 20.1672 14.1515"
        stroke="#3B2651"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7L13.1429 10.4286L16 11.5L13.1429 12.5715L12 16L10.8572 12.5715L8 11.5L10.8572 10.4286L12 7Z"
        stroke="url(#paint0_linear_7544_25285)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 15V19M16 17H20"
        stroke="#8E84EE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7544_25285"
          x1="12"
          y1="7"
          x2="12"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F84EF" />
          <stop offset="1" stopColor="#3C2752" />
        </linearGradient>
      </defs>
    </Icon24>
  );
};

const TaskTranscription: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_7289_6266)">
        <path
          d="M8.0134 13.6817L8.72518 13.918C8.80098 13.6898 8.76272 13.4391 8.62232 13.2438C8.48191 13.0486 8.25639 12.9325 8.01589 12.9317L8.0134 13.6817ZM5.54554 13.6735L5.54803 12.9235L5.5474 12.9235L5.54554 13.6735ZM16.1986 13.6817L16.9103 13.9182C16.9862 13.6899 16.9479 13.4392 16.8075 13.2439C16.6671 13.0486 16.4416 12.9325 16.2011 12.9317L16.1986 13.6817ZM13.7307 13.6735L13.7332 12.9235L13.7326 12.9235L13.7307 13.6735ZM14.1852 6.76947C14.1852 6.35525 13.8494 6.01947 13.4352 6.01947C13.021 6.01947 12.6852 6.35525 12.6852 6.76947H14.1852ZM6.88163 18.4104L7.03628 19.1443L6.88163 18.4104ZM8.01589 12.9317L5.54803 12.9235L5.54305 14.4235L8.01091 14.4317L8.01589 12.9317ZM5.5474 12.9235C5.72892 12.9239 6 13.0737 6 13.404H4.5C4.5 14.0315 5.03538 14.4222 5.54368 14.4235L5.5474 12.9235ZM6 13.404V6.76943H4.5V13.404H6ZM6 6.76943C6 7.10044 5.7281 7.25 5.54634 7.25V5.75C5.03726 5.75 4.5 6.14082 4.5 6.76943H6ZM5.54634 7.25H10.7685V5.75H5.54634V7.25ZM10.7685 7.25C10.5867 7.25 10.3148 7.10045 10.3148 6.76943H11.8148C11.8148 6.14081 11.2775 5.75 10.7685 5.75V7.25ZM10.3148 6.76943V13.1347H11.8148V6.76943H10.3148ZM6.02782 17.75C6.20988 17.75 6.48157 17.8998 6.48157 18.2305H4.98157C4.98157 18.8589 5.51843 19.25 6.02782 19.25V17.75ZM6.48157 16.0755C6.48157 16.4063 6.20988 16.5561 6.02782 16.5561V15.0561C5.51843 15.0561 4.98157 15.4472 4.98157 16.0755H6.48157ZM6.02782 16.5561C6.8489 16.5561 7.47415 15.9828 7.85693 15.5057C8.26583 14.996 8.57037 14.3842 8.72518 13.918L7.30163 13.4453C7.19742 13.7591 6.97375 14.2095 6.68691 14.567C6.37395 14.9571 6.13591 15.0561 6.02782 15.0561V16.5561ZM14.2129 16.5561C15.034 16.5561 15.6592 15.9828 16.042 15.5057C16.4509 14.9961 16.7555 14.3843 16.9103 13.9182L15.4868 13.4453C15.3826 13.7591 15.1589 14.2095 14.872 14.567C14.559 14.9571 14.321 15.0561 14.2129 15.0561V16.5561ZM16.2011 12.9317L13.7332 12.9235L13.7282 14.4235L16.1961 14.4317L16.2011 12.9317ZM13.7326 12.9235C13.914 12.924 14.1852 13.0736 14.1852 13.4041H12.6852C12.6852 14.0317 13.2208 14.4222 13.7289 14.4235L13.7326 12.9235ZM14.1852 13.4041V6.76947H12.6852V13.4041H14.1852ZM18.5 13.1348C18.5 14.189 18.0226 15.3583 17.2142 16.2675C16.409 17.1731 15.3409 17.75 14.213 17.75V19.25C15.867 19.25 17.3174 18.4089 18.3352 17.2642C19.3498 16.1231 20 14.6098 20 13.1348H18.5ZM14.213 17.75C14.3951 17.75 14.6668 17.8998 14.6668 18.2306H13.1668C13.1668 18.8589 13.7036 19.25 14.213 19.25V17.75ZM14.6668 18.2306V16.0756H13.1668V18.2306H14.6668ZM14.6668 16.0756C14.6668 16.4058 14.3955 16.5561 14.2129 16.5561V15.0561C13.7029 15.0561 13.1668 15.4478 13.1668 16.0756H14.6668ZM10.3148 13.1347C10.3148 14.0766 9.93392 15.1133 9.26951 15.9768C8.60636 16.8386 7.70577 17.4703 6.72698 17.6766L7.03628 19.1443C8.43268 18.8501 9.62368 17.9762 10.4583 16.8915C11.2917 15.8084 11.8148 14.4575 11.8148 13.1347H10.3148ZM6.72698 17.6766C6.49872 17.7247 6.26528 17.75 6.02782 17.75V19.25C6.37241 19.25 6.70949 19.2132 7.03628 19.1443L6.72698 17.6766ZM6.10602 19.2459L6.95984 19.1564L6.80342 17.6645L5.94961 17.754L6.10602 19.2459ZM6.48157 18.2305V17.153H4.98157V18.2305H6.48157ZM6.48157 17.153V16.0755H4.98157V17.153H6.48157Z"
          fill="#3B2651"
          fillOpacity="0.4"
        />
        <path
          d="M19.25 1.5L20.3929 4.92857L23.25 6L20.3929 7.07145L19.25 10.5L18.1072 7.07145L15.25 6L18.1072 4.92857L19.25 1.5Z"
          stroke="#D7D3DC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 18.5V22.5M1.25 20.5H5.25"
          stroke="#D7D3DC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7289_6266">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const TaskBroomstick: FC = () => {
  return (
    <Icon24>
      <g clipPath="url(#clip0_7289_80225)">
        <path
          d="M4.3335 3L4.90492 4.90476L6.3335 5.5L4.90492 6.09525L4.3335 8L3.76207 6.09525L2.3335 5.5L3.76207 4.90476L4.3335 3Z"
          stroke="#D7D3DC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.48701 13.8169L7.90945 9.81887L13.9704 15.8798L9.97229 22.3022C9.31835 21.946 7.46498 20.6881 5.28305 18.5062C3.10112 16.3243 1.84322 14.4709 1.48701 13.8169Z"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect
          x="11.647"
          y="9.31372"
          width="4"
          height="3"
          transform="rotate(45 11.647 9.31372)"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <rect
          x="19.4253"
          y="2.94971"
          width="2"
          height="10"
          transform="rotate(45 19.4253 2.94971)"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M17.3037 5.07104L18.7179 6.48526"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M7.8204 14.1803C8.16504 13.9505 8.25817 13.4848 8.02841 13.1402C7.79865 12.7956 7.33299 12.7024 6.98835 12.9322L7.8204 14.1803ZM6.98835 12.9322L2.74571 15.7606L3.57776 17.0087L7.8204 14.1803L6.98835 12.9322Z"
          fill="#B1A8B9"
        />
        <path
          d="M9.6088 15.9687C9.83856 15.624 10.3042 15.5309 10.6489 15.7607C10.9935 15.9904 11.0866 16.4561 10.8569 16.8007L9.6088 15.9687ZM10.8569 16.8007L8.02845 21.0434L6.78037 20.2113L9.6088 15.9687L10.8569 16.8007Z"
          fill="#B1A8B9"
        />
        <path
          d="M5.2829 18.5062L8.11133 15.6777"
          stroke="#B1A8B9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8335 14L19.8335 17.4286L22.3335 18.5L19.8335 19.5714L18.8335 23L17.8335 19.5714L15.3335 18.5L17.8335 17.4286L18.8335 14Z"
          stroke="#D7D3DC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7289_80225">
          <rect width="24" height="24" fill="white" transform="translate(0.333496)" />
        </clipPath>
      </defs>
    </Icon24>
  );
};

const TaskSummarization: FC = () => {
  return (
    <Icon24>
      <path
        d="M5.75 6.82617L7.17856 11.3976L10.75 12.8262L7.17856 14.2548L5.75 18.8262L4.32144 14.2548L0.75 12.8262L4.32144 11.3976L5.75 6.82617Z"
        stroke="#3B2651"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 7.32617H16M15.5 12.8262H21.75M11.75 18.0762H21.75"
        stroke="#3B2651"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.22 5.5V9.67391M18.3 7.58696H22.14"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const TaskArrow: FC = () => {
  return (
    <Icon24>
      <path
        d="M11.4697 23.5303C11.7626 23.8232 12.2374 23.8232 12.5303 23.5303L17.3033 18.7574C17.5962 18.4645 17.5962 17.9896 17.3033 17.6967C17.0104 17.4038 16.5355 17.4038 16.2426 17.6967L12 21.9393L7.75736 17.6967C7.46447 17.4038 6.98959 17.4038 6.6967 17.6967C6.40381 17.9896 6.40381 18.4645 6.6967 18.7574L11.4697 23.5303ZM11.25 1L11.25 23L12.75 23L12.75 1L11.25 1Z"
        fill="#3B2651"
        fillOpacity="0.4"
      />
    </Icon24>
  );
};

const TaskHighlighting: FC = () => {
  return (
    <Icon24>
      <path
        d="M21.372 21.2265H5L7.38137 18.8506"
        stroke="#B1A8B9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7598 4.74072L21.4813 8.46222L11.2889 18.6547H7.56738V14.9332L17.7598 4.74072Z"
        stroke="#B1A8B9"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M7.41504 14.8608C7.41504 14.8608 8.81611 14.8607 9.92221 15.9642C11.0283 17.0677 11.0283 18.4654 11.0283 18.4654"
        stroke="#B1A8B9"
        strokeWidth="1.5"
      />
      <path
        d="M20.5 14V18M18.5 16H22.5"
        stroke="#D7D3DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 3L7.14285 6.42857L10 7.5L7.14285 8.57145L6 12L4.85715 8.57145L2 7.5L4.85715 6.42857L6 3Z"
        stroke="#3B2651"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const Settings: FC = () => {
  return (
    <Icon24>
      <path
        d="M10.5 6H20.25M10.5 6C10.5 6.39782 10.342 6.77936 10.0607 7.06066C9.77936 7.34196 9.39782 7.5 9 7.5C8.60218 7.5 8.22064 7.34196 7.93934 7.06066C7.65804 6.77936 7.5 6.39782 7.5 6M10.5 6C10.5 5.60218 10.342 5.22064 10.0607 4.93934C9.77936 4.65804 9.39782 4.5 9 4.5C8.60218 4.5 8.22064 4.65804 7.93934 4.93934C7.65804 5.22064 7.5 5.60218 7.5 6M7.5 6H3.75M10.5 18H20.25M10.5 18C10.5 18.3978 10.342 18.7794 10.0607 19.0607C9.77936 19.342 9.39782 19.5 9 19.5C8.60218 19.5 8.22064 19.342 7.93934 19.0607C7.65804 18.7794 7.5 18.3978 7.5 18M10.5 18C10.5 17.6022 10.342 17.2206 10.0607 16.9393C9.77936 16.658 9.39782 16.5 9 16.5C8.60218 16.5 8.22064 16.658 7.93934 16.9393C7.65804 17.2206 7.5 17.6022 7.5 18M7.5 18H3.75M16.5 12H20.25M16.5 12C16.5 12.3978 16.342 12.7794 16.0607 13.0607C15.7794 13.342 15.3978 13.5 15 13.5C14.6022 13.5 14.2206 13.342 13.9393 13.0607C13.658 12.7794 13.5 12.3978 13.5 12M16.5 12C16.5 11.6022 16.342 11.2206 16.0607 10.9393C15.7794 10.658 15.3978 10.5 15 10.5C14.6022 10.5 14.2206 10.658 13.9393 10.9393C13.658 11.2206 13.5 11.6022 13.5 12M13.5 12H3.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon24>
  );
};

const SpreadsheetCsv: FC = () => {
  return (
    <Icon24>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 5.5H8.75V9.25H20.5V7C20.5 6.17157 19.8284 5.5 19 5.5ZM20.5 10.75H8.75V18.5H19C19.8284 18.5 20.5 17.8284 20.5 17V10.75ZM7.25 9.25V5.5H5C4.17157 5.5 3.5 6.17157 3.5 7V9.25H7.25ZM3.5 10.75H7.25V18.5H5C4.17157 18.5 3.5 17.8284 3.5 17V10.75ZM5 4C3.34315 4 2 5.34315 2 7V17C2 18.6569 3.34315 20 5 20H19C20.6569 20 22 18.6569 22 17V7C22 5.34315 20.6569 4 19 4H5Z"
        fill="currentColor"
      />
    </Icon24>
  );
};

export default {
  Plus,
  PlusTagGroup,
  Trash,
  Close,
  Arrow,
  Warning,
  Chevron,
  ChevronSimple,
  ChevronBadge,
  Tags,
  Italic,
  Bold,
  H1,
  H2,
  H3,
  OrderedList,
  BulletList,
  Link,
  Image,
  Badge,
  Video,
  ZoomIcon,
  Hide,
  Calendar,
  Lightning,
  ExclamationCircle,
  AISpinner,
  Insight,
  Tag,
  Theme,
  ArrowLeft,
  Transcript,
  Refresh,
  Search,
  Person,
  SWOT,
  UsabilityTesting,
  FocusGroup,
  LightBulb,
  QuestionMark,
  Highlight,
  AIStar,
  AIStarHighlights,
  Upload,
  ThumbUp,
  Heart,
  GoogleDriveIcon,
  OneDriveIcon,
  Dots,
  DotsVertical,
  ChevronDown,
  Maximaize,
  Smile,
  Folder,
  ChevronBold,
  Translate,
  Filter,
  Eye,
  EyeCrossed,
  AtSign,
  Comment,
  Chat,
  AddEmoji,
  HighlightAll,
  Clock,
  ChevronBack,
  Document,
  Folders,
  Participant,
  Miro,
  Spreadsheet,
  Canvas,
  Broomstick,
  Play,
  Pause,
  Brackets,
  Speaker,
  SpeakerMute,
  Scissors,
  SmartTemplate,
  SmartStars,
  SmartStarsBold,
  PostySmall,
  PostyGray,
  PostyPen,
  PostySend,
  PostyTag,
  PostySearch,
  PostyQuotes,
  PostyStars,
  TickCircle,
  PostyPenGray,
  PostySendGray,
  Paragraph,
  TaskTranscription,
  TaskArrow,
  TaskBroomstick,
  TaskSummarization,
  TaskHighlighting,
  Copy,
  PII,
  Cluster,
  ClusterGray,
  Settings,
  SpreadsheetCsv,
};
